import { useUrlState } from '@hcs/hooks';

// This allows other components to change the tab programmatically
export const useCardTabsState = (
  searchParamId: string,
  activeTabId?: string,
) => {
  const stateId = `tabsSection_${searchParamId}`;
  const INITIAL_STATE: { activeTabId: string | null } = {
    activeTabId: activeTabId || null,
  };
  const urlState = useUrlState(stateId, INITIAL_STATE);
  const setActiveTabId = (value: string) =>
    urlState.actions.patchUrlState([
      { op: 'add', path: '/activeTabId', value },
    ]);
  return {
    ...urlState,
    actions: {
      setActiveTabId,
    },
  };
};
